import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";
import { ResponseErrorHandling } from "../../../../helper";

export const checkClientKYCStatus = (clientId = null) => async (dispatch) => {
  try {
    const url = clientId
      ? `/user/get-sumsub-status?client_id=${clientId}`
      : `/user/get-sumsub-status`;
    const res = await commonService.get(url);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || err.toString();
    ResponseErrorHandling(err.response, dispatch);
    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response?.data;
  }
};
